import { Team__DublanCity } from "../teams/DublanCity";
import { Team__Potros } from "../teams/Potros";
import { Team__Pistons } from "../teams/Pistons";
import { Team__IrrigacionAgricola } from "../teams/IrrigacionAgricola";

const DublanCity = {
  team: Team__DublanCity,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const Pistons = {
  team: Team__Pistons,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

const IrrigacionAgricola = {
  team: Team__IrrigacionAgricola,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada3 = {
  jornadaPosition: 3,
  matches: [
    {
      team1: DublanCity,
      team2: Potros,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Pistons,
      team2: IrrigacionAgricola,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
